import { render, staticRenderFns } from "./BatchEdit.vue?vue&type=template&id=16f18a16&scoped=true&"
import script from "./BatchEdit.vue?vue&type=script&lang=js&"
export * from "./BatchEdit.vue?vue&type=script&lang=js&"
import style0 from "./BatchEdit.vue?vue&type=style&index=0&id=16f18a16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f18a16",
  null
  
)

export default component.exports